import {Modal, Typography} from '@logistics-frontend/blocks'
import {useI18n} from '@logistics-frontend/core/i18n'
import React from 'react'

import {PromoBannerButton} from '../promo-banner-button'
import {classes} from './PromoBannerPopupScreen.classes'
import {Props} from './PromoBannerPopupScreen.types'

const Base: React.FC<Props> = ({title, subtitle, lead_button, trail_button, isOpen, promoCode}) => {
  const t = useI18n()

  return (
    <Modal opened={isOpen}>
      <Modal.Header className={classes.header} title={title} hideClose />
      <Modal.Body className={classes.body}>
        <Typography
          dangerouslySetInnerHTML={{__html: t(subtitle)}}
          group="normal"
          thickness="regular"
          variant="body2"
        />
      </Modal.Body>
      <Modal.Footer>
        <Modal.Footer.Controls>
          <PromoBannerButton {...lead_button} promoCode={promoCode} />
          <PromoBannerButton {...trail_button} promoCode={promoCode} />
        </Modal.Footer.Controls>
      </Modal.Footer>
    </Modal>
  )
}

export const PromoBannerPopupScreen = React.memo(Base)
